import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ManageClubsFinal.css";
import QRCode from "qrcode.react";
import { userService } from "../../../_services";
import { useTranslation } from "react-i18next";
import NoClub from "../NoClub/NoClub";
import { Plus } from "lucide-react";

export default function ManageClubsFinal() {
    const navigate = useNavigate();
    const [allClubBusinessMemberShips, setAllClubBusinessMemberShips] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        const fetchClubs = async () => {
            try {
                const clubBusinessMemberShipsList = await userService.getAllClubsOfBusiness();
                setAllClubBusinessMemberShips(clubBusinessMemberShipsList);
            } catch (error){
                //toast.error(error);
            }finally {
                setIsLoading(false);
            }
        };
        fetchClubs();
    }, []);

    const downloadQRCode = (clubId) => {
        const qrCodeURL = document
            .getElementById(`qrCodeEl-${clubId}`)
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");

        const aEl = document.createElement("a");
        aEl.href = qrCodeURL;
        aEl.download = `QR_Code_${clubId}.png`;
        document.body.appendChild(aEl);
        aEl.click();
        document.body.removeChild(aEl);
    };

    return (
        <div className="clubs-container">
            {!isLoading && allClubBusinessMemberShips?.length > 0 && (
                <div className="club-header-buttons">
                <button
                    className="manage-clubs-add-button"
                    onClick={() => navigate("/home/ManageClubs/AddClub")}
                >
                    <Plus className="button-icon" />
                    {t('createClub')}
                </button>

                <button
                   className="manage-clubs-add-button"
                   onClick={() => navigate("/home/ManageClubs/JoinClub")}
                >
                  <Plus className="button-icon" />
                  {t('joinClub')}
               </button>
                </div>
            )}

            {!isLoading && allClubBusinessMemberShips?.length === 0 ? (
                <NoClub />
            ) : isLoading ? (
                null
            ) : (
                <div className="clubs-grid">
                    {allClubBusinessMemberShips.map((clubBusinessMemberShip) => (
                        <div key={clubBusinessMemberShip?.clubPublicInformation?.clubId} className="club-card">
                            <div className="club-content">
                                <div className="club-header">
                                    <h3>{clubBusinessMemberShip?.clubPublicInformation?.name}</h3>
                                    <div className="club-header-buttons">
                                        <button
                                            className="show-benefits-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                localStorage.setItem("clubBusinessMember", JSON.stringify(clubBusinessMemberShip));
                                                navigate(`/home/ManageClubs/${clubBusinessMemberShip?.id}/benefitsList`);
                                            }}
                                        >
                                            {t('showAvailableBenefits')}
                                        </button>
                                        <button
                                            className="club-add-benefit-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                localStorage.setItem("clubBusinessMember", JSON.stringify(clubBusinessMemberShip));
                                                navigate(`/home/ManageClubs/${clubBusinessMemberShip?.clubId}/benefits-explained`);
                                            }}
                                        >
                                            {t('addBenefit')}
                                        </button>
                                    </div>
                                </div>
                                <div className="club-details">
                                    <div className="detail-item">
                                        <span className="detail-label">{t('description')}</span>
                                        <span className="detail-value">{clubBusinessMemberShip?.clubPublicInformation?.description}</span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label">{t('email')}</span>
                                        <span className="detail-value">{clubBusinessMemberShip?.clubPublicInformation?.email}</span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label">{t('phoneNumber')}</span>
                                        <span className="detail-value">+{clubBusinessMemberShip?.clubPublicInformation?.phoneNum}</span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label">{t('type')}</span>
                                        <span className="detail-value">{clubBusinessMemberShip?.clubPublicInformation?.type}</span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label">{t('id')}</span>
                                        <span className="detail-value">{clubBusinessMemberShip?.clubPublicInformation?.id}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="qr-section">
                                <div className="qr-code">
                                    <QRCode id={`qrCodeEl-${clubBusinessMemberShip?.clubPublicInformation?.id}`}
                                            value={clubBusinessMemberShip?.clubPublicInformation?.deepLink} />
                                </div>
                                <button
                                    className="download-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        downloadQRCode(clubBusinessMemberShip?.clubPublicInformation?.id);
                                    }}
                                >
                                    {t('downloadQR')}
                                </button>
                            </div>
                            <div
                                className="club-card-overlay"
                                onClick={() => navigate(`/home/ManageClubs/${clubBusinessMemberShip?.clubPublicInformation?.id}/ben`)}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
